import { useEffect, useState } from 'react';
import { getSDK } from '@/store/sdkStore';
import { createLogger } from '@/lib/logger';

const log = createLogger('useAuditHistory');

export interface AuditRecord {
  id: string;
  operation: string;
  performedBy: string;
  performedAt: string;
  oldData?: string;
  newData?: string;
}

export interface UseAuditHistoryResult {
  records: AuditRecord[];
  loading: boolean;
  error: string | null;
  lastRecord: AuditRecord | null;
  refetch: () => Promise<void>;
}

export function useAuditHistory(
  entityType: string,
  entityCode: string,
  enabled: boolean = true
): UseAuditHistoryResult {
  const [records, setRecords] = useState<AuditRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRecords = async () => {
    if (!enabled || !entityType || !entityCode) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getSDK().metadata.getAuditHistory({
        entityType,
        entityCode,
        limit: 50,
      });
      const items = (res.records || []).map((r: any) => ({
        id: r.id || '',
        operation: r.operation || '',
        performedBy: r.performedBy || '',
        performedAt: r.performedAt || '',
        oldData: r.oldData || '',
        newData: r.newData || '',
      }));
      setRecords(items);
    } catch (e: any) {
      log.error('audit history load failed', e);
      setError(e?.message || 'Ошибка загрузки истории');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, entityCode, enabled]);

  return {
    records,
    loading,
    error,
    lastRecord: records.length > 0 ? records[0] : null,
    refetch: fetchRecords,
  };
}
